import { render } from "./popularCityList.vue?vue&type=template&id=19746ce5&scoped=true"
import script from "./popularCityList.vue?vue&type=script&lang=js"
export * from "./popularCityList.vue?vue&type=script&lang=js"

import "./popularCityList.vue?vue&type=style&index=0&id=19746ce5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19746ce5"]])

export default __exports__